import styled from "@emotion/styled";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Modal, ModalPortal, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { selectDefaultMailboxAddress } from "store/entities/license";
import { SettingsViewActions } from "store/views/settings";
import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

import { trackAddressCopied } from "../analytics";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import ProviderAccordions, { Location } from "./ProviderAccordions";

interface IProps {
  onClose: () => void;
  address?: string;
}

export enum Providers {
  Gmail = "gmail",
  Outlook = "outlook",
  Office = "office",
  Other = "other",
}

const InstructionsModal: FC<IProps> = ({ onClose, address }) => {
  const dispatch = useDispatch();

  const inboxAddress = useSelector(selectDefaultMailboxAddress);

  const usedAddress = address ?? inboxAddress;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onForwardingAddressCopy = () => {
    trackAddressCopied("instructions");
    dispatch(SettingsViewActions.forwardingAddressCopied());
  };

  return (
    <ModalPortal zIndex={StackingContextLevel.Modal}>
      <Modal onClose={onClose} heading="Forward your messages to HelpDesk">
        <ModalContent data-testid="instructions-modal">
          <ContentHeader data-testid="instructions-header">Choose your email provider</ContentHeader>
          <ProviderAccordions
            inboxAddress={usedAddress}
            onForwardingAddressCopy={onForwardingAddressCopy}
            location={Location.Settings}
          />
        </ModalContent>
      </Modal>
    </ModalPortal>
  );
};

const ContentHeader = styled(Text)`
  width: 562px;
  max-width: 100%;
  margin-bottom: ${withVar(SpacingToken.Spacing3)};
`;

const ModalContent = styled(Flex)`
  flex-direction: column;
  overflow-y: scroll;
  max-height: 88vh;
  box-sizing: border-box;
  padding: 0 ${withVar(SpacingToken.Spacing4)};

  .provider-accordion-item {
    width: unset;
  }
`;

export default InstructionsModal;
